export default __webpack_public_path__ + "static/media/bridal.5ba7bf9e.jpg";